import { CaseAuditCreateFeedbackRequest, CaseAuditCreateRequest, CaseAuditSelectionTypeResponse, OverturnAuditRequest, QaAgentAuditResultResponse, QAAuditPercentageUserDto, QaCaseAuditDeterminationResponse, QaCaseAuditRetrieveResponse, QARejectionAuditPercentageUserDto, QAUserAuditPercentage } from "interfaces/Mueller.Business.Models.ts";
import { MutableRefObject } from "react";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

/**
 * Gets the list of CaseAuditSelectionTypes
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns Mueller.Business.Models.CaseAudit.CaseAuditSelectionTypeResponse[]
 */
export const getSelectionTypes = (successCallback: (data?: CaseAuditSelectionTypeResponse[]) => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: "/qa-audit/selection-types",
  successCallback,
  mountedRef,
});

/**
 * Gets the current state and properties of the audit
 * @param {*} controlNumber 
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns Mueller.Business.Models.CaseAudit.QaCaseAuditRetrieveResponse
 */
export const retrieveAudit = (controlNumber: number, successCallback: (response?: QaCaseAuditRetrieveResponse) => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa-audit/cases/${controlNumber}`,
  successCallback,
  mountedRef,
});

/**
 * Creates a new audit
 * @param {*} controlNumber 
 * @param {*} request Mueller.Business.Models.CaseAudit.CaseAuditCreateRequest
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns void
 */
export const createAudit = (controlNumber: number, request: CaseAuditCreateRequest, successCallback: () => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa-audit/cases/${controlNumber}`,
  payload: request,
  successCallback,
  mountedRef,
});

/**
 * Creates a new audit feedback
 * @param {*} controlNumber 
 * @param {*} request Mueller.Business.Models.CaseAudit.CaseAuditCreateRequest
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns void
 */
export const createAuditFeedback = (controlNumber: number, request: CaseAuditCreateFeedbackRequest, successCallback: () => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa-audit/cases/${controlNumber}/feedback`,
  payload: request,
  successCallback,
  mountedRef,
});

/**
 * Overturns an audit
 * @param {*} controlNumber 
 * @param {*} request Mueller.Business.Models.CaseAudit.OverturnAuditRequest
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns void
 */
export const overturnAudit = (controlNumber: number, request: OverturnAuditRequest, successCallback: () => void, errorCallback: () => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa-audit/cases/${controlNumber}/overturn`,
  payload: request,
  successCallback,
  errorCallback,
  mountedRef,
});

/**
 * Gets the QA user's last 90 days of audits
 * @param {*} requestData
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns List<Mueller.Business.Models.CaseAudit.QaAgentAuditResultResponse>
 */
export const getUserAuditResults = ({ internetUserId, lookbackDays }: {internetUserId: number, lookbackDays: number }, successCallback: (response?: QaAgentAuditResultResponse) => void, mountedRef: MutableRefObject<boolean>) => {
  let endpoint = `/qa-audit/users/${internetUserId}/results/`;
  if (lookbackDays) {
    endpoint += `?lookbackDays=${lookbackDays}`;
  }

  return WebApiRequest({
    method: HTTP_GET,
    endpoint: endpoint,
    successCallback,
    mountedRef,
  });
};

/**
 * Gets the Case Audit Determination Results
 * @param {*} controlNumber 
 * @param {*} successCallback 
 * @param {*} mountedRef 
 * @returns Mueller.Business.Models.CaseAudit.QaCaseAuditDeterminationResponse
 */
export const getAuditDeterminationResults = (controlNumber: number, successCallback: (response?: QaCaseAuditDeterminationResponse) => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa-audit/cases/${controlNumber}/determination`,
  successCallback,
  mountedRef,
});

export const getAuditPercentage = (internetUserId: number, successCallback: (response?: QAAuditPercentageUserDto) => void, errorCallback: () => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa-audit/users/${internetUserId}/regular-percentage`,
  successCallback,
  errorCallback, 
  mountedRef
});
export const setAuditPercentage = (internetUserId: number, auditPercentage: number, successCallback: (response?: QAAuditPercentageUserDto) => void, errorCallback: () => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa-audit/users/${internetUserId}/regular-percentage`,
  payload: {
    AuditPercentage: auditPercentage,
  },
  successCallback,
  errorCallback, 
  mountedRef
});
export const getRejectionAuditPercentage = (internetUserId: number, successCallback: (response?: QARejectionAuditPercentageUserDto) => void, errorCallback: () => void, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/qa-audit/users/${internetUserId}/rejection-percentage`,
  successCallback,
  errorCallback, 
  mountedRef
});
export const setRejectionAuditPercentage = (internetUserId: number, rejectionAuditPercentage: number, successCallback: (response?: QARejectionAuditPercentageUserDto) => void, errorCallback, mountedRef: MutableRefObject<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/qa-audit/users/${internetUserId}/rejection-percentage`,
  payload: {
    RejectionAuditPercentage: rejectionAuditPercentage,
  },
  successCallback,
  errorCallback,
  mountedRef
});
